import { Link } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';
import { usePageTitle } from '../lib/usePageTitle';

/** 404: mai una pagina bianca — sempre una via d'uscita. */
export function NotFoundPage() {
  usePageTitle('Pagina non trovata');
  const { user } = useAuth();

  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-ink-200 px-4 py-3 dark:border-ink-800">
        <Link to="/" className="inline-flex items-center gap-2 text-xl font-bold no-underline">
          <img src="/favicon.png" alt="" width={36} height={36} className="h-9 w-9" />
          PandaCalcio
        </Link>
      </header>
      <main className="flex flex-1 flex-col items-center justify-center gap-4 px-4 py-16 text-center">
        <p aria-hidden="true" className="text-6xl">🐼</p>
        <h1 className="text-3xl font-bold tracking-tight">Questa pagina non esiste</h1>
        <p className="max-w-md text-lg text-ink-700 dark:text-ink-200">
          Forse il link è sbagliato o la pagina è stata spostata. Nessun problema: da qui si torna
          in campo.
        </p>
        <div className="mt-2 flex flex-wrap justify-center gap-3">
          <Link
            to={user ? '/dashboard' : '/'}
            className="button inline-flex min-h-11 items-center justify-center rounded-xl bg-panda-700 px-6 py-2.5 font-semibold text-white no-underline hover:bg-panda-800 dark:bg-panda-600"
          >
            {user ? 'Vai alla dashboard' : 'Torna alla home'}
          </Link>
          {user && (
            <Link
              to="/"
              className="inline-flex min-h-11 items-center justify-center rounded-xl border-2 border-ink-300 px-6 py-2.5 font-semibold no-underline dark:border-ink-600"
            >
              Torna alla home
            </Link>
          )}
        </div>
      </main>
    </div>
  );
}
